export default __webpack_public_path__ + "static/media/gallery_03.89bb156c.jpg";